import classNames from 'classnames'

import { EMPTY_OBJECT } from '../../../../../../constants/common'
import Button, { BUTTON_HEIGHT_40 } from '../../../../../Button'
import { ICON_HEIGHT_16 } from '../../../../../Icon'
import {
  ButtonTextSelectControl,
  useSelectContext,
} from '../../../../../Select'
import { Skeleton } from '../../../../../Skeleton'

import * as styles from './ListingProfileHeaderStatusSelectButton.module.css'

import ErrorIcon from '../../../../../../icons/error.svg'

function ListingProfileHeaderStatusSelectButton({
  className,
  isSkeleton,
  qaName,
  ref,
  refs,
  ...restProps
}) {
  const { blocked, disabled, value } = useSelectContext() || EMPTY_OBJECT

  const buttonStyle = {
    '--listing-profile-header-status-select-color':
      value?.textColor || 'var(--secondary-text-color)',
  }

  return isSkeleton ? (
    <Skeleton className={classNames(styles.skeleton, className)} />
  ) : (
    <ButtonTextSelectControl
      {...restProps}
      buttonProps={{
        Button: Button.Select,
        beforeIconProps: {
          Icon: value?.isWarning ? ErrorIcon : null,
          height: ICON_HEIGHT_16,
        },
        className: styles.button,
        disabled: blocked || disabled,
        height: BUTTON_HEIGHT_40,
        qaName,
        style: buttonStyle,
        text: value?.label,
        textClassName: styles.text,
      }}
      className={className}
      ref={ref}
      refs={refs}
    />
  )
}

export default ListingProfileHeaderStatusSelectButton
